import Vue from 'vue-property-decorator';
import {store} from '@/store';

export default {
    guestOnly: (to: any, from: object, next:CallableFunction) => {
        console.log(store.getters.userType);
        if((store.getters.userType == "guest" || store.getters.userType == "unknown") && to.path == "/login"){
            console.log("next");
            next();
        }
    }
}
